module.exports = "<div class=\"edit-export-role-overview\" *ngIf=\"canExportRoleOverview\">\n  <h3 class=\"edit-header\">Export role overview</h3>\n  <br />\n  <button class=\"sg-btn sg-blue edit-administer-btn\" *ngIf=\"canExportRoleOverview\" (click)=\"exportRoleOverview()\">Download overview</button>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/management/components/roleexport/roleexport.component.html
// module id = ./src/app/management/components/roleexport/roleexport.component.html
// module chunks = main